module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.order.clientPhone === '**********') ? _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "Номер телефона клиента доступен только для заказов в статусе 'В работе'. Если вам необходимо связаться с клиентом, то свяжитесь с ответственным мереджером в отделе продаж"
    }
  }, [(_vm.order.clientPhone) ? _c('span', [_vm._v("+7")]) : _vm._e(), _vm._v(_vm._s(_vm.order.clientPhone) + " " + _vm._s(_vm.order.clientName) + "\n    "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Ответственный " + _vm._s(_vm.order.user.firstname) + " " + _vm._s(_vm.order.user.lastname))])]) : _c('div', [(_vm.order.clientPhone) ? _c('span', [_vm._v("+7")]) : _vm._e(), _vm._v(_vm._s(_vm.order.clientPhone) + " " + _vm._s(_vm.order.clientName) + "\n    "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Ответственный " + _vm._s(_vm.order.user.firstname) + " " + _vm._s(_vm.order.user.lastname))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12c80aa8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-12c80aa8"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/OrderClientInfo.vue
// module id = 999
// module chunks = 1